import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */

function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (value) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var compact_1 = compact;
/**
 * Element.fn.matches
 */

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (selector) {
    var matches = document.querySelectorAll(selector);
    var i = matches.length;

    while (--i >= 0 && matches.item(i) !== this) {}

    return i > -1;
  };
}
/**
 * Node.fn.remove
 *
 * from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
 */


void [Node.prototype, Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function (item) {
  if (item.hasOwnProperty('remove')) {
    return;
  }

  item.remove = function () {
    if (this.parentNode !== null) {
      this.parentNode.removeChild(this);
    }
  };
});
/**
 * Element.fn.closest
 */

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = document.querySelectorAll(s);
    var el = this;
    var i = void 0;

    do {
      i = matches.length;

      while (--i >= 0 && matches.item(i) !== el) {}
    } while (i < 0 && (el = el.parentElement));

    return el;
  };
}

var INPUT_ARROW = "<svg width=\"6\" height=\"4\" viewBox=\"0 0 6 4\"><path d=\"M3 0l3 4H0\"></path></svg>";
var DROPDOWN_ARROW = "<svg viewBox=\"0 0 8 3\"><path d=\"M4.654.233L8 3H0L3.383.23c.37-.303.902-.302 1.27.003z\" /></svg>";
var GUIDE_ARROW = "<svg width=\"27\" height=\"8\"><path d=\"M15.069 6.66a3.27 3.27 0 0 1-3.13 0L0 0h27.008l-11.94 6.66z\" /></svg>";
var CLOSE_FILLED = "<svg width=\"16\" height=\"16\"><path d=\"M8 6.945L6.218 5.163a.688.688 0 0 0-.973.972l1.783 1.782L5.245 9.7a.688.688 0 0 0 .973.972L8 8.89l1.782 1.782a.688.688 0 0 0 .973-.972L8.972 7.917l1.783-1.782a.688.688 0 0 0-.973-.972L8 6.945zm-5.185 6.24a7.333 7.333 0 1 1 10.37-10.37 7.333 7.333 0 0 1-10.37 10.37z\"/></svg>";
var svg =
/*#__PURE__*/
Object.freeze({
  INPUT_ARROW: INPUT_ARROW,
  DROPDOWN_ARROW: DROPDOWN_ARROW,
  GUIDE_ARROW: GUIDE_ARROW,
  CLOSE_FILLED: CLOSE_FILLED
});

function trimList(list) {
  return compact_1(list).join(' ');
}

var duoList = [{
  "id": "save",
  "layer": ["arrow", "cloud"]
}, {
  "id": "inspect",
  "layer": ["slash", "bracket"]
}, {
  "id": "play",
  "layer": ["arrow", "circle"]
}, {
  "id": "evenly_distribute_h",
  "layer": ["indicator", "object"]
}, {
  "id": "evenly_distribute_v",
  "layer": ["indicator", "object"]
}, {
  "id": "widget_align_bottom",
  "layer": ["indicator", "object"]
}, {
  "id": "widget_align_center",
  "layer": ["indicator", "object"]
}, {
  "id": "widget_align_left",
  "layer": ["indicator", "object"]
}, {
  "id": "widget_align_right",
  "layer": ["indicator", "object"]
}, {
  "id": "widget_align_top",
  "layer": ["indicator", "object"]
}, {
  "id": "widget_align_v_center",
  "layer": ["indicator", "object"]
}];

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ICON_SET_LIST = ['dora', 'mb', 'icon', 'fa', 'md', 'ci'];
var LIGA_ICON_SET_LIST = ['dora', 'md'];

var checkIfIconIsLiga = function checkIfIconIsLiga(type) {
  return LIGA_ICON_SET_LIST.includes(type);
};

function Icon(_ref) {
  var _ref$name = _ref.name,
      propName = _ref$name === undefined ? '' : _ref$name,
      type = _ref.type,
      className = _ref.className,
      others = objectWithoutProperties(_ref, ['name', 'type', 'className']);
  var prefix = type === 'mb' ? 'icon' : type;
  var name = propName.replace(new RegExp('^(' + ICON_SET_LIST.join('|') + ')-', 'i'), '');
  var isLiga = checkIfIconIsLiga(type);
  return React.createElement('span', _extends({
    className: trimList(['icon', type, !isLiga && prefix + '-' + name, className])
  }, others), isLiga && name);
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.string
};
Icon.defaultProps = {
  name: '',
  type: 'icon'
};
var DUO_ICON_NAME_MAP = {
  dora: 'duodora'
};

function DuoIcon(_ref2) {
  var name = _ref2.name,
      type = _ref2.type,
      className = _ref2.className,
      colorList = _ref2.colorList,
      others = objectWithoutProperties(_ref2, ['name', 'type', 'className', 'colorList']);
  var icon = duoList.find(function (_ref3) {
    var id = _ref3.id;
    return id === name;
  });
  return !!icon && React.createElement('span', _extends({
    className: trimList(['duo-icon', DUO_ICON_NAME_MAP[type], className])
  }, others), icon.layer.map(function (l, idx) {
    return React.createElement('span', {
      key: l,
      className: 'layer',
      style: {
        color: colorList[idx]
      }
    }, name + '__' + l);
  }));
}

DuoIcon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.keys(DUO_ICON_NAME_MAP)),
  className: PropTypes.string,
  colorList: PropTypes.array
};
DuoIcon.defaultProps = {
  name: '',
  type: 'dora',
  colorList: []
};
Icon.DuoIcon = DuoIcon;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".--mb--color-picker .theme-palette {\n    display: flex;\n    padding: 8px 0 10px;\n    margin: 0;\n  }\n\n    .--mb--color-picker .theme-palette .theme-palette-color {\n      list-style: none;\n      width: 18px;\n      height: 18px;\n      cursor: pointer;\n      border-radius: 2px;\n      border: 1px solid rgba(0, 0, 0, 0.12);\n    }\n\n    .--mb--color-picker .theme-palette .theme-palette-color:not(:last-child) {\n        margin-right: 10px;\n      }\n\n    .--mb--color-picker .theme-palette .theme-palette-color.transparent {\n        position: relative;\n        overflow: hidden;\n        background-image: linear-gradient(45deg, #ccc 26%, transparent 26%), linear-gradient(-45deg, #ccc 26%, transparent 26%), linear-gradient(45deg, transparent 73%, #ccc 73%), linear-gradient(-45deg, transparent 73%, #ccc 73%);\n        background-size: 6px 6px;\n        background-position: 0 0, 0 3px, 3px -3px, -3px 0;\n      }\n";
styleInject(css);

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty$1 = function defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray$1 = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var Theme = function (_Component) {
  inherits(Theme, _Component);

  function Theme() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Theme);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Theme.__proto__ || Object.getPrototypeOf(Theme)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var color = e.currentTarget.dataset.color;

      _this.props.handleSelect(color);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Theme, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var themes = this.props.themes;
      return React.createElement('ul', {
        className: 'theme-palette'
      }, themes.map(function (color, i) {
        return React.createElement('li', {
          key: i,
          className: 'theme-palette-color' + (color === 'transparent' ? ' transparent' : ''),
          style: {
            backgroundColor: color
          },
          'data-color': color,
          onClick: _this2.handleClick
        });
      }));
    }
  }]);
  return Theme;
}(Component);

Theme.propTypes = {
  themes: PropTypes.array,
  onClose: PropTypes.func,
  handleSelect: PropTypes.func
};
var css$1 = ".--mb--color-picker .custom-color-list {\n    padding: 10px 0;\n    border-top: 1px solid #dedee4;\n  }\n\n    .--mb--color-picker .custom-color-list .custom-palette {\n      display: flex;\n      flex-wrap: wrap;\n      margin: 0;\n      padding: 0;\n    }\n\n    .--mb--color-picker .custom-color-list .custom-palette-color-imagback {\n      background-image: linear-gradient(45deg, #ccc 26%, transparent 26%), linear-gradient(-45deg, #ccc 26%, transparent 26%), linear-gradient(45deg, transparent 73%, #ccc 73%), linear-gradient(-45deg, transparent 73%, #ccc 73%);\n      background-size: 6px 6px;\n      background-position: 0 0, 0 3px, 3px -3px, -3px 0;\n      background-clip: padding-box;\n      overflow: hidden;\n    }\n\n    .--mb--color-picker .custom-color-list .custom-palette-color-li {\n        height: 100%;\n    }\n\n    .--mb--color-picker .custom-color-list .custom-palette-color {\n      list-style: none;\n      width: 18px;\n      height: 18px;\n      cursor: pointer;\n      margin-top: 10px;\n    }\n\n    .--mb--color-picker .custom-color-list .custom-palette-color li {\n        border-radius: 2px;\n        border: 1px solid rgba(0, 0, 0, 0.12);\n      }\n\n    .--mb--color-picker .custom-color-list .custom-palette-color:not(:nth-child(9n)) {\n        margin-right: 10px;\n      }\n";
styleInject(css$1);

var CustomColors = function (_PureComponent) {
  inherits(CustomColors, _PureComponent);

  function CustomColors() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, CustomColors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = CustomColors.__proto__ || Object.getPrototypeOf(CustomColors)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (e) {
      var color = e.target.dataset.color;

      _this.props.handleSelect(color);
    }, _this.getOpacityPerc = function (value) {
      var opacityPerc = value.split(',');
      var len = opacityPerc.length;
      var showBg = len > 3 && +opacityPerc[len - 1].replace(')', '') !== 1;
      return showBg;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(CustomColors, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          customColors = _props.customColors,
          customColorsHeaderText = _props.customColorsHeaderText;
      if (customColors.length === 0) return null;
      return React.createElement('div', {
        className: 'custom-color-list'
      }, React.createElement('header', null, React.createElement('div', null, customColorsHeaderText)), React.createElement('ul', {
        className: 'custom-palette'
      }, customColors.map(function (color, i) {
        return React.createElement('div', {
          key: i,
          className: 'custom-palette-color ' + (_this2.getOpacityPerc(color) ? 'custom-palette-color-imagback' : '')
        }, React.createElement('li', {
          className: 'custom-palette-color-li',
          style: {
            backgroundColor: color
          },
          'data-color': color,
          onClick: _this2.handleSelect
        }));
      })));
    }
  }]);
  return CustomColors;
}(PureComponent);

CustomColors.defaultProps = {
  customColorsHeaderText: 'Custom Colors'
};
CustomColors.propTypes = {
  customColors: PropTypes.array,
  handleSelect: PropTypes.func,
  customColorsHeaderText: PropTypes.string
}; // -----------------------
// referring to:
// https://gist.github.com/mjackson/5311256
// Assumes:
// h, s, and v in the set [0, 1]
// r, g, and b in the set [0, 255]

var hsv2rgb = function hsv2rgb(_ref) {
  var h = _ref.h,
      s = _ref.s,
      v = _ref.v;

  var _r = void 0,
      _g = void 0,
      _b = void 0;

  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);

  switch (i % 6) {
    case 0:
      _r = v, _g = t, _b = p;
      break;

    case 1:
      _r = q, _g = v, _b = p;
      break;

    case 2:
      _r = p, _g = v, _b = t;
      break;

    case 3:
      _r = p, _g = q, _b = v;
      break;

    case 4:
      _r = t, _g = p, _b = v;
      break;

    case 5:
      _r = v, _g = p, _b = q;
      break;
  }

  return {
    r: Math.round(_r * 255),
    g: Math.round(_g * 255),
    b: Math.round(_b * 255)
  };
};

var rgb2hsv = function rgb2hsv(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;

  var _r = r / 255;

  var _g = g / 255;

  var _b = b / 255;

  var max = Math.max(_r, _g, _b);
  var min = Math.min(_r, _g, _b);
  var h = void 0,
      s = void 0,
      v = max;
  var d = max - min;
  s = max == 0 ? 0 : d / max;

  if (max == min) {
    h = 0;
  } else {
    if (max == _r) {
      h = (_g - _b) / d + (_g < _b ? 6 : 0);
    } else if (max == _g) {
      h = (_b - _r) / d + 2;
    } else if (max == _b) {
      h = (_r - _g) / d + 4;
    }

    h /= 6;
  }

  return {
    h: h || 0,
    s: s || 0,
    v: v || 0
  };
};

var hex2rgb = function hex2rgb(hex) {
  if (hex.toLowerCase() === 'transparent') {
    return {
      r: 255,
      g: 255,
      b: 255
    };
  } else {
    var _hex = hex.replace(/^#/, '');

    return {
      r: parseInt(_hex.substr(0, 2), 16),
      g: parseInt(_hex.substr(2, 2), 16),
      b: parseInt(_hex.substr(4, 2), 16)
    };
  }
}; // -----------------------


var dec2twoDigitHex = function dec2twoDigitHex(dec) {
  return Number(dec).toString(16).replace(/(^.$)/, '0$1');
};

var rgb2hex = function rgb2hex(_ref3) {
  var r = _ref3.r,
      g = _ref3.g,
      b = _ref3.b;
  return '#' + dec2twoDigitHex(r) + dec2twoDigitHex(g) + dec2twoDigitHex(b);
};

var hex2rgbaStr = function hex2rgbaStr(hex, alpha) {
  var _hex2rgb = hex2rgb(hex),
      r = _hex2rgb.r,
      g = _hex2rgb.g,
      b = _hex2rgb.b;

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
};

var rgb2rgbaStr = function rgb2rgbaStr(_ref4) {
  var r = _ref4.r,
      g = _ref4.g,
      b = _ref4.b,
      _ref4$a = _ref4.a,
      a = _ref4$a === undefined ? 1 : _ref4$a;
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
};

var formatHex = function formatHex(hex) {
  var v = hex.replace(/^#/, '');
  if (v.length === 6) return hex;
  if (v.length === 3) return '#' + v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
};

var stopReactEventPropagation = function stopReactEventPropagation(e) {
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};

var css$2 = ".--mb--color-picker .hsv-picker .s-v-plane {\n      position: relative;\n      height: 120px;\n      margin-bottom: 10px;\n      border: 1px solid rgba(0, 0, 0, 0.12);\n      border-radius: 2px;\n      background-clip: content-box;\n      overflow: hidden;\n    }\n\n.--mb--color-picker .hsv-picker .s-v-plane .pointer {\n        position: absolute;\n        width: 6px;\n        height: 6px;\n        margin: -3px;\n        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);\n        border: 1px solid white;\n        border-radius: 50%;\n        pointer-events: none;\n      }\n\n.--mb--color-picker .hsv-picker .s-v-plane .base-hue-layer,\n      .--mb--color-picker .hsv-picker .s-v-plane .s-layer,\n      .--mb--color-picker .hsv-picker .s-v-plane .v-layer {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        pointer-events: none;\n      }\n\n.--mb--color-picker .hsv-picker .s-v-plane .s-layer {\n        -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr='#ffffff', endColorstr='#00ffffff')\";\n        background: -moz-linear-gradient(left, white 0%, rgba(255, 255, 255, 0) 100%);\n        background: -webkit-gradient(linear, left top, right top, color-stop(0%, white), color-stop(100%, rgba(255, 255, 255, 0)));\n        background: -webkit-linear-gradient(left, white 0%, rgba(255, 255, 255, 0) 100%);\n        background: -o-linear-gradient(left, white 0%, rgba(255, 255, 255, 0) 100%);\n        background: -ms-linear-gradient(left, white 0%, rgba(255, 255, 255, 0) 100%);\n        background: linear-gradient(to right, white 0%, rgba(255, 255, 255, 0) 100%);\n        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr='#ffffff', endColorstr='#00ffffff');\n      }\n\n.--mb--color-picker .hsv-picker .s-v-plane .v-layer {\n        -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#00000000', endColorstr='#000000')\";\n        background: -moz-linear-gradient(top, transparent 0%, black 100%);\n        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, transparent), color-stop(100%, black));\n        background: -webkit-linear-gradient(top, transparent 0%, black 100%);\n        background: -o-linear-gradient(top, transparent 0%, black 100%);\n        background: -ms-linear-gradient(top, transparent 0%, black 100%);\n        background: linear-gradient(to bottom, transparent 0%, black 100%);\n        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000',GradientType=0 );\n      }\n\n.--mb--color-picker .hsv-picker .row {\n      display: flex;\n      align-items: center;\n    }\n\n.--mb--color-picker .hsv-picker .outside-color-picker-btn {\n      width: 24px;\n      height: 24px;\n      margin-right: 8px;\n      cursor: pointer;\n      border: 1px solid #8d9ea7;\n      border-radius: 2px;\n      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n.--mb--color-picker .hsv-picker .h-a-bands {\n      flex: 1;\n      margin-right: 8px;\n    }\n\n.--mb--color-picker .hsv-picker .h-band,\n    .--mb--color-picker .hsv-picker .a-band {\n      position: relative;\n      height: 10px;\n      border: 1px solid rgba(0, 0, 0, 0.12);\n      border-radius: 2px;\n      cursor: pointer;\n      background-clip: padding-box;\n    }\n\n.--mb--color-picker .hsv-picker .h-band .rail {\n        position: absolute;\n        top: 1px;\n        bottom: 1px;\n        left: 3.5px;\n        right: 3.5px;\n      }\n\n.--mb--color-picker .hsv-picker .a-band .rail {\n        position: absolute;\n        top: 1px;\n        bottom: 1px;\n        left: 3.5px;\n        right: 3.5px;\n      }\n\n.--mb--color-picker .hsv-picker .h-band .slider {\n        position: absolute;\n        top: -3px;\n        width: 5px;\n        height: 12px;\n        margin-left: -2.5px;\n        background: #f6f7f8;\n        box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.34);\n        border-radius: 3px;\n        z-index: 2;\n        pointer-events: none;\n      }\n\n.--mb--color-picker .hsv-picker .a-band .slider {\n        position: absolute;\n        top: -3px;\n        width: 5px;\n        height: 12px;\n        margin-left: -2.5px;\n        background: #f6f7f8;\n        box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.34);\n        border-radius: 3px;\n        z-index: 2;\n        pointer-events: none;\n      }\n\n.--mb--color-picker .hsv-picker .h-band {\n      margin-bottom: 4px;\n      background-image: linear-gradient(to left, red, #ff0080, magenta, #8000ff, blue, #0080ff, cyan, #00ff80, lime, #80ff00, yellow, #ff8000, red);\n    }\n\n.--mb--color-picker .hsv-picker .a-band {\n      background-image:\n        linear-gradient(45deg, #ccc 25%, transparent 25%),\n        linear-gradient(-45deg, #ccc 25%, transparent 25%),\n        linear-gradient(45deg, transparent 75%, #ccc 75%),\n        linear-gradient(-45deg, transparent 75%, #ccc 75%);\n      background-size: 6px 6px;\n      background-position: 0 0, 0 3px, 3px -3px, -3px 0;\n    }\n\n.--mb--color-picker .hsv-picker .preview-container {\n      width: 24px;\n      height: 24px;\n      border: 1px solid #dedede;\n      border-radius: 2px;\n      background-image: linear-gradient(45deg,#ccc 25%,transparent 0),linear-gradient(-45deg,#ccc 25%,transparent 0),linear-gradient(45deg,transparent 75%,#ccc 0),linear-gradient(-45deg,transparent 75%,#ccc 0);\n      background-size: 12px 12px;\n      background-position: -1px -1px, -1px 5px, 5px -7px, -7px -1px;\n    }\n";
styleInject(css$2);

var HSVPicker = function (_PureComponent) {
  inherits(HSVPicker, _PureComponent);

  function HSVPicker() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, HSVPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = HSVPicker.__proto__ || Object.getPrototypeOf(HSVPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      h: null,
      s: null,
      v: null,
      hex: null,
      a: null,
      // changingFromInside: this value indicates that color changes from inside
      // component, which we choose not to accept changes from outside, cause when
      // `v` in hsv is near 0, the output of converting hsv value to rgb, or vice versa,
      // becomes unstable(`h` value and `s` value), which causing pointer to tremble
      changingFromInside: false
    }, _this.setSVPlaneRef = function (ref) {
      return _this.$SVPlane = ref;
    }, _this.setHBandRef = function (ref) {
      return _this.$HBand = ref;
    }, _this.setABandRef = function (ref) {
      return _this.$ABand = ref;
    }, _this.handleClickEyedropper = function () {}, _this._getBaseHue = function (h) {
      return rgb2hex(hsv2rgb({
        h: h,
        s: 1,
        v: 1
      }));
    }, _this._getSVPointerStyle = function (s, v) {
      // s for x, v for y, remember v decreases while y increases
      return {
        top: 100 - v * 100 + '%',
        left: s * 100 + '%'
      };
    }, _this._getSVValue = function (x, y) {
      // s for x, v for y, remember v decreases while y increases
      var SVPlaneRect = _this.$SVPlane.getBoundingClientRect();

      return {
        s: Math.min(1, Math.max(0, x - SVPlaneRect.left) / SVPlaneRect.width),
        v: 1 - Math.min(1, Math.max(0, y - SVPlaneRect.top) / SVPlaneRect.height)
      };
    }, _this._getHPointerStyle = function (h) {
      return {
        left: h * 100 + '%'
      };
    }, _this._getAPointerStyle = function (a) {
      return {
        left: a * 100 + '%'
      };
    }, _this._getHValue = function (x) {
      var HBandRect = _this.$HBand.getBoundingClientRect();

      return {
        h: Math.min(1, Math.max(0, x - HBandRect.left) / HBandRect.width)
      };
    }, _this._getAValue = function (x) {
      var ABandRect = _this.$ABand.getBoundingClientRect();

      var a = Math.min(1, Math.max(0, x - ABandRect.left) / ABandRect.width);
      return {
        a: Math.round(a * 100) / 100
      };
    }, _this.handleDragSVPlane = function (e) {
      stopReactEventPropagation(e);
      e.preventDefault();

      var _this$_getSVValue = _this._getSVValue(e.clientX, e.clientY),
          s = _this$_getSVValue.s,
          v = _this$_getSVValue.v;

      var h = _this.state.h;
      var hex = rgb2hex(hsv2rgb({
        h: h,
        s: s,
        v: v
      }));

      _this.setState({
        h: h,
        s: s,
        v: v,
        hex: hex,
        changingFromInside: true
      });

      _this.props.onChange({
        hex: hex
      });

      var onMouseMove = function onMouseMove(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        if (!_this.$SVPlane) return;

        var _this$_getSVValue2 = _this._getSVValue(e.clientX, e.clientY),
            s = _this$_getSVValue2.s,
            v = _this$_getSVValue2.v;

        var h = _this.state.h;
        var hex = rgb2hex(hsv2rgb({
          h: h,
          s: s,
          v: v
        }));

        _this.setState({
          h: h,
          s: s,
          v: v,
          hex: hex
        });

        _this.props.onChange({
          hex: hex
        });
      };

      var onMouseUp = function onMouseUp(e) {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        if (!_this.$SVPlane) return;

        var _this$_getSVValue3 = _this._getSVValue(e.clientX, e.clientY),
            s = _this$_getSVValue3.s,
            v = _this$_getSVValue3.v;

        var h = _this.state.h;
        var hex = rgb2hex(hsv2rgb({
          h: h,
          s: s,
          v: v
        }));

        _this.setState({
          h: h,
          s: s,
          v: v,
          hex: hex
        });

        _this.props.onConfirm({
          hex: hex
        });

        _this.setState({
          changingFromInside: false
        });
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }, _this.handleDragHBand = function (e) {
      stopReactEventPropagation(e);
      e.preventDefault();

      var _this$_getHValue = _this._getHValue(e.clientX),
          h = _this$_getHValue.h;

      var _this$state = _this.state,
          s = _this$state.s,
          v = _this$state.v;
      var hex = rgb2hex(hsv2rgb({
        h: h,
        s: s,
        v: v
      }));

      _this.setState({
        h: h,
        s: s,
        v: v,
        hex: hex,
        changingFromInside: true
      });

      _this.props.onChange({
        hex: hex
      });

      var onMouseMove = function onMouseMove(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        if (!_this.$HBand) return;

        var _this$_getHValue2 = _this._getHValue(e.clientX),
            h = _this$_getHValue2.h;

        var _this$state2 = _this.state,
            s = _this$state2.s,
            v = _this$state2.v;
        var hex = rgb2hex(hsv2rgb({
          h: h,
          s: s,
          v: v
        }));

        _this.setState({
          h: h,
          s: s,
          v: v,
          hex: hex
        });

        _this.props.onChange({
          hex: hex
        });
      };

      var onMouseUp = function onMouseUp(e) {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        if (!_this.$HBand) return;

        var _this$_getHValue3 = _this._getHValue(e.clientX),
            h = _this$_getHValue3.h;

        var _this$state3 = _this.state,
            s = _this$state3.s,
            v = _this$state3.v;
        var hex = rgb2hex(hsv2rgb({
          h: h,
          s: s,
          v: v
        }));

        _this.setState({
          h: h,
          s: s,
          v: v,
          hex: hex
        });

        _this.props.onConfirm({
          hex: hex
        });

        _this.setState({
          changingFromInside: false
        });
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }, _this.handleDragABand = function (e) {
      stopReactEventPropagation(e);
      e.preventDefault();

      var _this$_getAValue = _this._getAValue(e.clientX),
          a = _this$_getAValue.a;

      _this.setState({
        changingFromInside: true
      });

      _this.props.onChange({
        a: a
      });

      var onMouseMove = function onMouseMove(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        if (!_this.$ABand) return;

        var _this$_getAValue2 = _this._getAValue(e.clientX),
            a = _this$_getAValue2.a;

        _this.props.onChange({
          a: a
        });
      };

      var onMouseUp = function onMouseUp(e) {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        if (!_this.$ABand) return;

        var _this$_getAValue3 = _this._getAValue(e.clientX),
            a = _this$_getAValue3.a;

        _this.setState({
          a: a
        });

        _this.props.onConfirm({
          a: a
        });

        _this.setState({
          changingFromInside: false
        });
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(HSVPicker, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          h = _state.h,
          s = _state.s,
          v = _state.v,
          a = _state.a;

      var baseHue = this._getBaseHue(h);

      var SVPointerStyle = this._getSVPointerStyle(s, v);

      var HPointerStyle = this._getHPointerStyle(h);

      var APointerStyle = this._getAPointerStyle(a);

      return React.createElement('div', {
        className: 'hsv-picker'
      }, React.createElement('section', {
        className: 's-v-plane',
        ref: this.setSVPlaneRef,
        onMouseDown: this.handleDragSVPlane
      }, React.createElement('div', {
        className: 'base-hue-layer',
        style: {
          background: baseHue
        }
      }), React.createElement('div', {
        className: 's-layer'
      }), React.createElement('div', {
        className: 'v-layer'
      }), React.createElement('i', {
        className: 'pointer',
        style: SVPointerStyle
      })), React.createElement('div', {
        className: 'row'
      }, this.props.children && React.createElement('div', {
        className: 'outside-color-picker-btn'
      }, this.props.children), React.createElement('div', {
        className: 'h-a-bands'
      }, React.createElement('div', {
        className: 'h-band',
        onMouseDown: this.handleDragHBand
      }, React.createElement('div', {
        className: 'rail',
        ref: this.setHBandRef
      }, React.createElement('span', {
        className: 'slider',
        style: HPointerStyle
      }))), React.createElement('div', {
        className: 'a-band',
        onMouseDown: this.handleDragABand
      }, React.createElement('div', {
        style: {
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to right, transparent 0%, ' + rgb2rgbaStr(hsv2rgb({
            h: h,
            s: s,
            v: v
          })) + ' 100%)'
        }
      }), React.createElement('div', {
        className: 'rail',
        ref: this.setABandRef
      }, React.createElement('span', {
        className: 'slider',
        style: APointerStyle
      })))), React.createElement('div', {
        className: 'preview-container'
      }, React.createElement('div', {
        style: {
          height: '100%',
          background: rgb2rgbaStr(_extends$1({}, hsv2rgb({
            h: h,
            s: s,
            v: v
          }), {
            a: a
          }))
        }
      }))));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var newState = null;

      if (!state.changingFromInside && props.hex !== state.hex && props.hex !== 'transparent') {
        newState = _extends$1({}, newState, {
          hex: props.hex
        }, rgb2hsv(hex2rgb(props.hex)));
      }

      if (props.alpha !== state.a) newState = _extends$1({}, newState, {
        a: props.alpha
      });
      return newState;
    }
  }]);
  return HSVPicker;
}(PureComponent);

HSVPicker.propTypes = {
  hex: PropTypes.string,
  alpha: PropTypes.number,
  onChange: PropTypes.func,
  onConfirm: PropTypes.func,
  children: PropTypes.node
};
var css$3 = ".--mb--color-picker .color-input {\n    width: 36px;\n  }\n\n.--mb--color-picker .color-input span {\n      display: block;\n      line-height: 12px;\n      margin-top: 4px;\n      color: #8d9ea7;\n      text-align: center;\n    }\n\n.--mb--color-picker .color-input input {\n      width: 100%;\n      height: 22px;\n      padding: 0 4px;\n      background: #f6f7f8;\n      border: 1px solid #f2f2f3;\n      border-radius: 2px;\n      color: #415058;\n      align-self: stretch;\n      line-height: 1;\n      overflow: hidden;\n      transition: 0.2s ease-out;\n      transition-property: border, box-shadow;\n    }\n\n.--mb--color-picker .color-input input:hover {\n        border-color: #1e98ea;\n      }\n\n.--mb--color-picker .color-input input:focus {\n        border-color: #1e98ea;\n        box-shadow: 0 0 6px 0 rgba(30, 152, 234, 0.5);\n      }\n\n.--mb--color-picker .color-input input.invalid {\n        border-color: #e84030;\n        box-shadow: 0 0 6px 0 rgba(232, 64, 48, 0.5);\n      }\n";
styleInject(css$3);

var RGBInput = function (_PureComponent) {
  inherits(RGBInput, _PureComponent);

  function RGBInput() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, RGBInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = RGBInput.__proto__ || Object.getPrototypeOf(RGBInput)).call.apply(_ref, [this].concat(args))), _this), _this._originalValueOfInput = '', _this._invalidFace = '', _this._changedMannually = false, _this.state = {
      r: null,
      g: null,
      b: null,
      prevHexFromProps: null
    }, _this.selectWhenClick = function (e) {
      e.target.select();
      _this._originalValueOfInput = e.target.value;
    }, _this._correctInput = function (value) {
      return value.replace(/\D/g, '').slice(0, 3);
    }, _this.handleChange = function (e) {
      _this._changedMannually = true;
      var face = e.target.dataset.face;

      var value = _this._correctInput(e.target.value);

      _this.validate(face, value);

      _this.setState(defineProperty$1({}, face, value));
    }, _this.validate = function (face, value) {
      if (value === '' || Number(value) > 255) {
        _this._invalidFace = face;
        return false;
      } else {
        _this._invalidFace = '';
        return true;
      }
    }, _this.emitChange = function () {
      if (!_this._changedMannually) return;
      var _this$state = _this.state,
          r = _this$state.r,
          g = _this$state.g,
          b = _this$state.b;

      _this.props.handleChange({
        r: r,
        g: g,
        b: b
      });
    }, _this.handleBlur = function (e) {
      var face = e.target.dataset.face;

      if (face === _this._invalidFace) {
        _this.setState(defineProperty$1({}, face, _this._originalValueOfInput));
      } else {
        _this.emitChange();
      }

      _this._invalidFace = '';
      _this._originalValueOfInput = '';
    }, _this.handleEnter = function (e) {
      if (e.key !== 'Enter') return;
      var face = e.target.dataset.face;

      if (face === _this._invalidFace) {
        _this.setState(defineProperty$1({}, face, _this._originalValueOfInput));
      } else {
        _this._originalValueOfInput = _this.state[face];

        _this.emitChange();
      }

      _this._invalidFace = '';
      e.target.select();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(RGBInput, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          r = _state.r,
          g = _state.g,
          b = _state.b;
      return React.createElement(React.Fragment, null, React.createElement('label', {
        className: 'color-input'
      }, React.createElement('input', {
        className: this._invalidFace === 'r' ? 'invalid' : '',
        'data-face': 'r',
        value: r,
        onClick: this.selectWhenClick,
        onKeyUp: this.handleEnter,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }), React.createElement('span', null, 'R')), React.createElement('label', {
        className: 'color-input'
      }, React.createElement('input', {
        className: this._invalidFace === 'g' ? 'invalid' : '',
        'data-face': 'g',
        value: g,
        onClick: this.selectWhenClick,
        onKeyUp: this.handleEnter,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }), React.createElement('span', null, 'G')), React.createElement('label', {
        className: 'color-input'
      }, React.createElement('input', {
        className: this._invalidFace === 'b' ? 'invalid' : '',
        'data-face': 'b',
        value: b,
        onClick: this.selectWhenClick,
        onKeyUp: this.handleEnter,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }), React.createElement('span', null, 'B')));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.hex !== state.prevHexFromProps && props.hex !== 'transparent') {
        return _extends$1({}, hex2rgb(props.hex), {
          prevHexFromProps: props.hex
        });
      } else if (props.hex !== state.prevHexFromProps && props.hex === 'transparent') {
        return {
          r: 255,
          g: 255,
          b: 255,
          prevHexFromProps: 'transparent'
        };
      } else {
        return null;
      }
    }
  }]);
  return RGBInput;
}(PureComponent);

RGBInput.propTypes = {
  hex: PropTypes.string,
  handleChange: PropTypes.func
};

var HexInput = function (_PureComponent) {
  inherits(HexInput, _PureComponent);

  function HexInput() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, HexInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = HexInput.__proto__ || Object.getPrototypeOf(HexInput)).call.apply(_ref, [this].concat(args))), _this), _this._invalid = false, _this._originalValueOfInput = '', _this._changedMannually = false, _this.$input = null, _this.state = {
      // naming `hexValue` here cause we store the value without `#`
      hexValue: null,
      prevHexValueFromProps: null
    }, _this.setInputRef = function (ref) {
      return _this.$input = ref;
    }, _this.selectWhenClick = function (e) {
      e.target.select();
      _this._originalValueOfInput = e.target.value;
    }, _this._correctInput = function (value) {
      return value.toUpperCase().replace(/[^0-9A-F]/g, '').slice(0, 6);
    }, _this.handleChange = function (e) {
      _this._changedMannually = true;

      var value = _this._correctInput(e.target.value);

      if (value.length === 3 || value.length === 6) {
        _this._invalid = false;
      } else {
        _this._invalid = true;
      }

      _this.setState({
        hexValue: value
      });
    }, _this._format3DigitValue = function (v) {
      return '' + v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    }, _this.formatAndHandleChange = function () {
      if (!_this._changedMannually) return;
      var hexValue = _this.state.hexValue;
      var formattedValue = hexValue;

      if (hexValue.length === 3) {
        formattedValue = _this._format3DigitValue(formattedValue);

        _this.setState({
          hexValue: formattedValue
        });
      }

      formattedValue.toLowerCase();

      _this.props.handleChange(formattedValue);

      return formattedValue;
    }, _this.handleBlur = function (e) {
      if (_this._invalid) {
        _this.setState({
          hexValue: _this._originalValueOfInput
        });
      } else {
        _this.formatAndHandleChange();
      }

      _this._invalid = false;
      _this._originalValueOfInput = '';
    }, _this.handleEnter = function (e) {
      if (e.key !== 'Enter') return;

      if (_this._invalid) {
        _this.setState({
          hexValue: _this._originalValueOfInput
        });
      } else {
        var formattedValue = _this.formatAndHandleChange();

        _this._originalValueOfInput = formattedValue;
      }

      _this._invalid = false;
      e.target.select();
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // _invalid:
  // default to false if do not change


  createClass(HexInput, [{
    key: 'render',
    value: function render() {
      var hexValue = this.state.hexValue;
      var inputValue = hexValue;

      if (hexValue === 'TRANSPARENT' || hexValue === 'transparent') {
        inputValue = 'FFFFFF';
      }

      return React.createElement('label', {
        className: 'color-input',
        style: {
          width: '58px'
        }
      }, React.createElement('input', {
        ref: this.setInputRef,
        value: inputValue,
        onClick: this.selectWhenClick,
        onKeyUp: this.handleEnter,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }), React.createElement('span', null, 'Hex'));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var propsValue = props.hexValue.toUpperCase();

      if (propsValue !== state.prevHexValueFromProps) {
        return {
          prevHexValueFromProps: propsValue,
          hexValue: propsValue
        };
      } else {
        return null;
      }
    }
  }]);
  return HexInput;
}(PureComponent);

HexInput.propTypes = {
  hexValue: PropTypes.string,
  handleChange: PropTypes.func
};

var AlphaInput = function (_PureComponent) {
  inherits(AlphaInput, _PureComponent);

  function AlphaInput() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AlphaInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AlphaInput.__proto__ || Object.getPrototypeOf(AlphaInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      a: null,
      prevAFromProps: null
    }, _this.selectWhenClick = function (e) {
      e.target.select();
      _this._originalValueOfInput = e.target.value;
    }, _this.handleChange = function (e) {
      var value = e.target.value.replace(/\D/g, '');
      value = value.replace(/^0*(?=[0-9])/, ''); // 000000

      if (value.match(/^100/)) {
        value = value.slice(0, 3);
      } else {
        value = value.slice(0, 2);
      }

      _this.setState({
        a: value
      });
    }, _this.handleBlur = function (e) {
      return _this.props.handleChangeAlpha(_this.state.a / 100);
    }, _this.handleEnter = function (e) {
      if (e.key !== 'Enter') return;

      _this.props.handleChangeAlpha(_this.state.a / 100);

      e.target.select();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AlphaInput, [{
    key: 'render',
    value: function render() {
      var a = this.state.a;
      return React.createElement('label', {
        className: 'color-input'
      }, React.createElement('input', {
        value: a,
        onClick: this.selectWhenClick,
        onKeyUp: this.handleEnter,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }), React.createElement('span', null, 'A'));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.a !== state.prevAFromProps) return {
        a: props.a,
        prevAFromProps: props.a
      };
      return null;
    }
  }]);
  return AlphaInput;
}(PureComponent);

AlphaInput.propTypes = {
  a: PropTypes.number,
  handleChangeAlpha: PropTypes.func
};
var css$4 = ".--mb--color-picker {\n  box-sizing: border-box;\n  position: absolute;\n  width: 262px;\n  color: #415058;\n  background: white;\n  border-radius: 4px;\n  box-shadow: 0 -2px 20px 0 rgba(39, 54, 78, 0.11);\n  font-size: 12px;\n  text-align: left;\n}\n\n  .--mb--color-picker * {\n    box-sizing: border-box;\n  }\n\n  .--mb--color-picker input {\n    outline: none;\n  }\n\n  .--mb--color-picker .header-text {\n    font-size: 12px;\n    line-height: 1;\n    font-weight: normal;\n  }\n\n  .--mb--color-picker .input-section {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 1px;\n    margin-top: 10px;\n    margin-bottom: 12px;\n  }\n\n  .--mb--color-picker .color-picker-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 30px;\n    padding: 0 10px;\n    cursor: move;\n  }\n\n  .--mb--color-picker .color-picker-header .icon {\n      padding: 3px;\n      margin-right: -3px;\n      box-sizing: content-box;\n      color: #8d9ea7;\n      font-size: 12px;\n      cursor: pointer;\n    }\n\n  .--mb--color-picker .color-picker-header .icon:hover {\n        color: #415058;\n      }\n\n  .--mb--color-picker .color-picker-body {\n    padding: 0 10px;\n  }\n";
styleInject(css$4);

var DUMB_FUNC = function DUMB_FUNC() {
  return null;
};

var ColorPicker = function (_PureComponent) {
  inherits(ColorPicker, _PureComponent);

  function ColorPicker() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hex: null,
      alpha: null
    }, _this.setContainerRef = function (ref) {
      return _this.$container = ref;
    }, _this.handleDragStart = function (e) {
      e.preventDefault();

      if (_this.props.onDragStart) {
        _this.props.onDragStart(e);
      }
    }, _this.handleClose = function (e) {
      return _this.props.onClose(e);
    }, _this.handleColorChangeFromExternal = function (color) {
      var _parseColor = parseColor(color),
          hex = _parseColor.hex,
          alpha = _parseColor.alpha;

      _this.hsvConfirm({
        hex: hex,
        a: alpha
      });
    }, _this.handleRgbChange = function (rgb) {
      var hex = rgb2hex(rgb);
      var changeFromTransparent = _this.state.hex === 'transparent';

      _this.hsvConfirm({
        hex: hex,
        a: changeFromTransparent ? 1 : _this.state.alpha
      });
    }, _this.handleHexChange = function (hexValue) {
      var hex = '#' + hexValue;
      var changeFromTransparent = _this.state.hex === 'transparent';

      _this.hsvConfirm({
        hex: hex,
        a: changeFromTransparent ? 1 : _this.state.alpha
      });
    }, _this.hsvChange = function (_ref2) {
      var hex = _ref2.hex,
          a = _ref2.a;

      var _parseColor2 = parseColor(_this.props.color),
          propsHex = _parseColor2.hex;

      if (!hex) hex = _this.state.hex;
      if (!a && a !== 0) a = _this.state.alpha;

      if (hex === 'transparent' && a === 0) {
        _this.props.onChange('transparent');
      } else if (hex === 'transparent' && a !== 0) {
        _this.props.onChange(hex2rgbaStr('FFFFFF', a));
      } else {
        _this.props.onChange(hex2rgbaStr(hex, propsHex === 'transparent' ? 1 : a));
      }
    }, _this.hsvConfirm = function (_ref3) {
      var hex = _ref3.hex,
          a = _ref3.a;

      var _parseColor3 = parseColor(_this.props.color),
          propsHex = _parseColor3.hex;

      if (!hex) hex = _this.state.hex;
      if (!a && a !== 0) a = _this.state.alpha;

      if (hex === 'transparent') {
        _this.props.onConfirm('transparent');
      } else {
        _this.props.onConfirm(hex2rgbaStr(hex, propsHex === 'transparent' ? 1 : a));
      }
    }, _this.handleChangeAlpha = function (a) {
      return _this.hsvConfirm({
        hex: _this.state.hex,
        a: a
      });
    }, _this.genOutsideColorPicker = function () {
      var passedOutsideColorPicker = _this.props.children;
      return React.cloneElement(passedOutsideColorPicker, {
        hex: _this.state.hex,
        alpha: _this.state.alpha,
        handleChange: _this.hsvConfirm
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ColorPicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.applyDidMountSideEffect(this.$container);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.applyWillUnmountSideEffect(this.$container);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          themeColors = _props.themeColors,
          customColors = _props.customColors,
          onClose = _props.onClose,
          customColorsHeaderText = _props.customColorsHeaderText;
      var _state = this.state,
          hex = _state.hex,
          alpha = _state.alpha;
      var hexValue = hex === 'transparent' ? 'TRANSPARENT' : hex.slice(1);
      var outsideColorPicker = void 0;
      if (this.props.children) outsideColorPicker = this.genOutsideColorPicker();
      return React.createElement('div', {
        className: '--mb--color-picker',
        ref: this.setContainerRef,
        onMouseDown: stopReactEventPropagation,
        onClick: stopReactEventPropagation
      }, React.createElement('header', {
        className: 'color-picker-header',
        onMouseDown: this.handleDragStart
      }, React.createElement('div', {
        className: 'header-text'
      }, this.props.headerText), onClose && React.createElement(Icon, {
        type: 'dora',
        name: 'times',
        onMouseDown: this.handleClose
      })), React.createElement('div', {
        className: 'color-picker-body'
      }, themeColors && React.createElement(Theme, {
        themes: themeColors,
        handleSelect: this.handleColorChangeFromExternal
      }), React.createElement(HSVPicker, {
        hex: hex,
        alpha: alpha,
        onChange: this.hsvChange,
        onConfirm: this.hsvConfirm
      }, outsideColorPicker), React.createElement('div', {
        className: 'input-section'
      }, React.createElement(HexInput, {
        hexValue: hexValue,
        handleChange: this.handleHexChange
      }), React.createElement(RGBInput, {
        hex: hex,
        handleChange: this.handleRgbChange
      }), React.createElement(AlphaInput, {
        a: parseInt(alpha * 100),
        handleChangeAlpha: this.handleChangeAlpha
      })), customColors && React.createElement(CustomColors, {
        customColors: customColors,
        customColorsHeaderText: customColorsHeaderText,
        handleSelect: this.handleColorChangeFromExternal
      })));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var _parseColor4 = parseColor(props.color),
          hex = _parseColor4.hex,
          alpha = _parseColor4.alpha;

      if (hex.toLowerCase() === state.props && alpha === state.alpha) {
        return null;
      } else {
        return {
          hex: hex,
          alpha: alpha
        };
      }
    }
  }]);
  return ColorPicker;
}(PureComponent);

ColorPicker.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func,
  onConfirm: PropTypes.func,
  applyDidMountSideEffect: PropTypes.func,
  applyWillUnmountSideEffect: PropTypes.func,
  themeColors: PropTypes.array,
  customColors: PropTypes.array,
  customColorsHeaderText: PropTypes.string,
  onDragStart: PropTypes.func,
  onClose: PropTypes.func,
  headerText: PropTypes.string,
  children: PropTypes.node
};
ColorPicker.defaultProps = {
  applyDidMountSideEffect: DUMB_FUNC,
  applyWillUnmountSideEffect: DUMB_FUNC,
  headerText: 'Color Picker'
};

var parseColor = function parseColor(c) {
  var color = c.trim().toLowerCase(); // keep lower cases hex in the component

  var rgbaExtractor = /^rgba?\((.*)\)$/;

  if (color.match(/transparent/)) {
    return {
      hex: 'transparent',
      alpha: 0
    };
  } else if (color.match(/^#[0-9a-f]{6}$|^#[0-9a-f]{3}$/)) {
    return {
      hex: formatHex(color),
      alpha: 1
    };
  } else if (color.match(rgbaExtractor)) {
    var rgbaStr = rgbaExtractor.exec(color)[1];

    var _rgbaStr$split$map = rgbaStr.split(',').map(function (i) {
      return i.trim();
    }),
        _rgbaStr$split$map2 = slicedToArray$1(_rgbaStr$split$map, 4),
        r = _rgbaStr$split$map2[0],
        g = _rgbaStr$split$map2[1],
        b = _rgbaStr$split$map2[2],
        a = _rgbaStr$split$map2[3];

    return {
      hex: rgb2hex({
        r: parseInt(r),
        g: parseInt(g),
        b: parseInt(b)
      }),
      alpha: !a ? 1 : parseFloat(a)
    };
  } else {
    return DEFAULT_COLOR;
  }
};

var DEFAULT_COLOR = {
  hex: '#000000',
  alpha: 1
};
export default ColorPicker;
export { parseColor };